"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = void 0;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_config_provider = (0, vue_1.resolveComponent)("el-config-provider");
  return (0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_el_config_provider, {
    locale: $setup.elLocale
  }, {
    default: (0, vue_1.withCtx)(() => [$setup.layout ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)((0, vue_1.resolveDynamicComponent)($setup.layout), {
      key: 0
    })) : (0, vue_1.createCommentVNode)("", true)]),
    _: 1
  }, 8, ["locale"]);
}
exports.render = render;